<template>
  <div class="text-center painel">
    <background-wrapper>
      <div>
        <h1 class="mb-2">Criar nova senha</h1>
        <h2 class="brand-primary--text mb-2">{{ userName }}</h2>
      </div>

      <cs-message
        :type="error.type"
        v-if="error.message[0]"
        v-model="error.message"
        class="errorMessage"
      />
      <cs-message v-show="responseErrors.length > 0" :value="responseErrors" class="errorMessage" />
      <v-form ref="form" class="setPasswordForm" id="PasswordForm">
        <cs-text-field
          id="PasswordForm"
          ref="password"
          v-model.trim="password"
          label="Senha"
          :error-messages="passwordErrors"
          @change="validateField"
          validateOnBlur
          password
          required
        />
        <cs-text-field
          id="PasswordForm"
          ref="confirmPassword"
          class="password bottomSpace"
          v-model="confirmPassword"
          label="Repetir Senha"
          :error-messages="confirmPasswordErrors"
          @change="validadeConfirmPassword"
          validateOnBlur
          password
          required
        />
        <PassWordCheck :password="password" :length="passwordLength" />

        <cs-recaptcha
          class="bottomSpace"
          ref="vue_recaptcha"
          v-model="recaptcha"
          :sitekey="$store.state.global.recaptchaKey"
        />
        <csButton
          class="w-100"
          :style="{ color: !formIsInvalid ? '#fff' : '#888888 !important' }"
          :loading="loading"
          :disabled="formIsInvalid"
          @click.prevent="sendRequest"
        >
          Redefinir senha
        </csButton>
      </v-form>
    </background-wrapper>
  </div>
</template>

<script>
import loginService from '@/services/loginService'
import Util from '@/components/Util.js'
import csButton from '@/components/campos/csButton.vue'
import csMessage from '@/components/campos/csMessage.vue'
import csRecaptcha from '@/components/campos/csRecaptcha.vue'
import CsTextField from '@/components/campos/csTextField.vue'
import BackgroundWrapper from '@/components/background/BackgroundWrapper.vue'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'

const strongPassword = (password) => Util.validateStrongPassword(password)
const consecutiveCharactersPassword = (password) => Util.validateConsecutiveCharacters(password)
const containsReservedWords = (password) => Util.validatePasswordContainsReservedWords(password)

export default {
  mixins: [loginService],
  validations() {
    return {
      password: {
        required,
        strongPassword,
        minLength: minLength(8),
        maxLength: maxLength(12),
        consecutiveCharactersPassword,
        containsReservedWords
      },
      confirmPassword: { required }
    }
  },
  components: {
    csButton,
    csRecaptcha,
    csMessage,
    CsTextField,
    BackgroundWrapper
  },
  props: {
    token: {
      type: String,
      required: true
    },
    fullName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      password: '',
      confirmPassword: '',
      recaptcha: '',
      loading: false,
      responseErrors: [],
      termsAccepted: false,
      rules: {
        matchPassword: (value) => value === this.password || 'As senhas não são iguais.'
      },
      error: {
        type: '',
        message: []
      }
    }
  },
  computed: {
    passwordErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Esse campo é obrigatório.')
      if (errors.length > 0) return errors
      !this.$v.password.strongPassword &&
        errors.push(
          'A senha deve ter letras, números e ao menos um caracter especial (ex: @, #, $)'
        )
      !this.$v.password.consecutiveCharactersPassword &&
        errors.push('A senha não deve possuir 3 caracteres sequenciais consecutivos')
      !this.$v.password.containsReservedWords &&
        errors.push('A senha não deve possuir as palavras senha, mudar ou password')
      !this.$v.password.minLength && errors.push('A senha deve ter entre 8 e 12 caracteres')
      !this.$v.password.maxLength && errors.push('A senha deve ter entre 8 e 12 caracteres')
      return errors
    },
    confirmPasswordErrors() {
      const errors = []
      if (!this.$v.confirmPassword.$dirty) return errors
      !this.$v.confirmPassword.required && errors.push('Esse campo é obrigatório.')
      if (this.password !== this.confirmPassword) {
        errors.push('As senhas não correspondem. Tente novamente.')
        return errors
      }
      return errors
    },
    formIsInvalid() {
      return !(
        this.password &&
        this.confirmPassword &&
        this.recaptcha !== '' &&
        this.passwordErrors.length === 0
      )
    },
    userName() {
      const name = this.fullName.trim().split(' ')
      return name.length === 1 ? name[0] : name[0] + ' ' + name[name.length - 1]
    }
  },
  methods: {
    mergeErros(erros) {
      let response = []
      for (const chave in erros) {
        response = response.concat(erros[chave])
      }
      return response
    },

    async sendRequest() {
      this.error.message = []
      this.loading = true
      try {
        const response = await this.setPassword(
          this.password,
          this.confirmPassword,
          this.token,
          this.recaptcha
        )
        const _errors = response.data && response.data.errors
        this.responseErrors = _errors ? this.mergeErros(_errors) : []
        if (response.status === 200) {
          this.$router.replace({ name: 'home' })
        }
      } catch {
        this.responseErrors = ['Ocorreu um erro. Tente novamente']
      } finally {
        this.loading = false
        this.$refs.vue_recaptcha.reset()
        this.recaptcha = ''
      }
    },
    validateField() {
      this.responseErrors = []
      this.$v.password.$touch()
    },
    validadeConfirmPassword() {
      this.responseErrors = []
      this.$v.confirmPassword.$touch()
    }
  }
}
</script>

<style lang="scss" scoped>
#PasswordForm {
  right: 600px;

  width: 350px;
}
.setPasswordForm,
.errorMessage {
  width: 100%;
  max-width: 304px;
}
.password {
  margin-bottom: 1rem;
}
.bottomSapace {
  margin-bottom: 1rem;
}
</style>
